/* istanbul ignore file */
import React from 'react';
import { Trans } from 'lingui-react';
import { get } from 'lodash';

import makeCellColumn from './builder';

export default makeCellColumn({
  columnName: 'city',
  label: <Trans>City</Trans>,
  text: cellData => get(cellData, ['displayAddress', 'city']),
});



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealersTable/columns/city.js